import instance from "../http";
import { getDeviceData, getHeader, setandgetCookies } from "../../utils/utils";
import { authPath } from "../../constants/path";

export async function signUpAPI(_signupData) {
    const deviceData = getDeviceData();
    let signup_data = { ..._signupData, ...deviceData }
    const response = await instance.post(
        authPath.SIGNUP_PATH,
        signup_data,
        ''
    );
    return response;
}

export async function loginAPI(_loginData) {
    const deviceData = getDeviceData();
    let login_data = { ..._loginData, ...deviceData }
    const response = await instance.post(authPath.LOGIN_PATH, login_data, '');
    return response;
}

export async function verifyEmialAPI(_token) {
    const response = await instance.put(`${authPath.VERIFY_EMAIL_PATH}?email_verify=${_token}`);
    return response;
}

export async function activateAccountAPI(data) {
    const response = await instance.put(authPath.SET_USER_PASSWORD, data, "");
    return response;
}

export async function logoutAPI() {
    const deviceId = setandgetCookies();
    const headers = getHeader();
    const response = await instance.post(`${authPath.LOGOUT_PATH}`, { device_id: deviceId }, headers);
    return response;
}

export async function forgotPasswordAPI(_email) {
    const response = await instance.post(authPath.FORGOT_PASSWORD_PATH, _email, '');
    return response;
}

export async function resetPasswordAPI(_password, _token) {
    const response = await instance.post(authPath.RESET_PASSWORD_PATH + _token, { password: _password }, '');
    return response;
}

export async function refreshTokenAPI() {
    const deviceData = getDeviceData();
    const refreshToken = localStorage.getItem("_refreshToken");
    let data = { refreshToken, ...deviceData }
    const headers = getHeader();
    const response = await instance.post(authPath.REFRESH_TOKEN, data, headers);
    return response;
}